import { render, staticRenderFns } from "./PlainSideBar.vue?vue&type=template&id=535e611d"
import script from "./PlainSideBar.vue?vue&type=script&lang=js"
export * from "./PlainSideBar.vue?vue&type=script&lang=js"
import style0 from "./PlainSideBar.vue?vue&type=style&index=0&id=535e611d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports